<div class="container-fluid dialog-body">
    <mat-dialog-content><span class="message">{{data.message}}</span></mat-dialog-content>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-raised-button color="alert" (click)="dialogRef.close(false)">{{'Cancel' | translate}}</button>
        <button mat-raised-button color="warn" class="button" (click)="dialogRef.close(true)">{{'Confirm' | translate}}</button>
    </mat-dialog-actions>
</div>